import React from 'react';
import { clsx } from 'clsx';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
  success?: boolean;
}

export const Textarea: React.FC<TextareaProps> = ({
  label,
  error,
  hint,
  success,
  className,
  id,
  rows = 3,
  ...props
}) => {
  const textareaId = id || `textarea-${label?.toLowerCase().replace(/\s+/g, '-')}`;
  
  const textareaClasses = clsx(
    'block w-full rounded-lg border-2 px-4 py-3 text-gray-900 transition-all duration-200',
    'placeholder:text-gray-400 focus:outline-none',
    'min-h-[120px] resize-y',
    {
      'border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-500/20': error,
      'border-green-300 focus:border-green-500 focus:ring-2 focus:ring-green-500/20': success && !error,
      'border-gray-200 hover:border-gray-300 focus:border-[#4B5FDC] focus:ring-2 focus:ring-[#4B5FDC]/20': !error && !success,
    },
    className
  );

  return (
    <div className="space-y-1">
      {label && (
        <label htmlFor={textareaId} className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      
      <textarea
        id={textareaId}
        className={textareaClasses}
        rows={rows}
        {...props}
      />
      
      {(error || hint) && (
        <p className={clsx('text-sm', error ? 'text-red-600' : 'text-gray-500')}>
          {error || hint}
        </p>
      )}
    </div>
  );
};

export default Textarea;